import { FieldError } from 'react-hook-form'

const isFieldError = (a: unknown): a is FieldError => {
  const b = a as FieldError
  return typeof b !== 'undefined' && typeof b.type === 'string'
}

export const isRequiredError = (error?: unknown | FieldError) =>
  isFieldError(error) && error.type === 'required'
export const isMaxLengthError = (error?: unknown | FieldError) =>
  isFieldError(error) && error.type === 'maxLength'
export const isMinLengthError = (error?: unknown | FieldError) =>
  isFieldError(error) && error.type === 'minLength'
export const isPatternError = (error?: unknown | FieldError) =>
  isFieldError(error) && error.type === 'pattern'
export const isValidateError = (error?: unknown | FieldError) =>
  isFieldError(error) && error.type === 'validate'

export const emailInputPattern = /\S+@\S+\.\S+/
